import Api from "../api";
const { axios: api } = Api;
const queryString = require("query-string");

const PREFIX = "common";

export const getCommonData = async (payload) => {
  const data = await api.get(`/${PREFIX}`, payload);
  return { data: data.data };
};
